 import { Cash } from "../types/cash"; 
import { createApiStore } from "./genericStore";
 
export const useCashStore = createApiStore<Cash>("/cash");
